export default "__VITE_ASSET__D0wE4B2d__"